import { render, staticRenderFns } from "./FeaturesTab.vue?vue&type=template&id=e9536000&scoped=true&"
import script from "./FeaturesTab.vue?vue&type=script&lang=js&"
export * from "./FeaturesTab.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesTab.vue?vue&type=style&index=0&id=e9536000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9536000",
  null
  
)

component.options.__file = "FeaturesTab.vue"
export default component.exports